export default {
  variants: {
    stepper: {
      tab: {
        padding: 0,
      },
    },
  },
};
